export default {
  "userActivityTable.date": "Date",
  "userActivityTable.initiatedByEmail": "Initiated Email",
  "userActivityTable.initiatedByUser": "Initiated By",
  "userActivityTable.userAffectedEmail": "User Email",
  "userActivityTable.userAffectedUser": "User Affected",
  "userActivityTable.action": "Action",
};
